import { Nav, NavDropdown, Image, } from 'react-bootstrap'
import { FaShoppingCart, FaSearch, FaSignOutAlt, FaUserCircle } from "react-icons/fa"
import { Notification, Search } from './Block'
import Link from 'next/link'
import navStyles from './topnav.module.css'
import Authenticator from '@group-devs/yfp7-authenticator'
import { Request } from '@group-devs/yfp7-global-modules'
import { useState, useEffect } from 'react'
import { isDomain } from '../utils/general'

const request = new Request(process.env.apiDomain)

function RightSectionNav({props, avatar, shop, notification, auth, site, origin, items}) {

    const [email, setEmail] = useState('')
    const code = site.site.code;

    const {data: siteUrl} = request.website.swrSite(site.accountId, code);
    const {data: wellness} = request.website.swrSite(site.accountId, "WC");

    const url = siteUrl ? (isDomain(siteUrl.url) ? 'www.'+siteUrl.url : siteUrl.url) : '';
    const userId = auth.isAuthenticated ? auth.userId : null;
    const {data: user} = request.account.swrUserProfile(userId);

    let point = 0;

    let contactAccount = props.contactAccount
    const [contactId, setContactId] = useState(null);

    useEffect(() => {
        if(typeof contactAccount != 'undefined'){
            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    useEffect(() => {
        const Email = user ? user.user.email : '';
        setEmail(Email);
    }, [user])

    if(props.auth.site_user){
    
        const contact_id = contactId;
        const { data: iqPoints} = request.stats.IQPoints(contact_id);
        point = iqPoints ? iqPoints.points : 0;

        if(code == "BC"){
            var profileUrl = siteUrl ? 'https://'+url+'/explore/my-profile' : '#';
        }else{
            var profileUrl = siteUrl ? 'https://'+url+'/myprofile' : '#';
        }
        
        
    }else{

        var profileUrl = process.env.backofficeDomain+'/account-profile';
    }

    return (
        <Nav className="align-items-center ml-auto navbar-exeption order-lg-2 mt-lg-2">

            {(!auth.isAuthenticated) ? 
                <Link href={site.url ? '/login?redirect=/home' :'/login?redirect=/choose-destination'} passHref>
                    <Nav.Link className="px-lg-3 py-lg-0 py-3 login">Login</Nav.Link>
                </Link>
                :
                <>
                                   
                    {/*<Link href={wellness ? "https://"+wellness.url+"/learn-and-earn/overview" : '#'} passHref>
                        <Nav.Link className="h7 d-xl-flex d-none">
                            <Image src="../images/general/img-bright-star.svg" className="mr-3"/>You have &nbsp;<u>{point} points</u>
                        </Nav.Link>
                    </Link>*/}

                    <Link href={shop} passHref><Nav.Link target="_blank" className="d-lg-inline-block d-none"><FaShoppingCart size="20"/></Nav.Link></Link>
                    <div className="notification-dropdown">
                        <Notification props={props} notification={notification} origin={origin}/>
                    </div>
                    <div className="search-dropdown">
                        <NavDropdown alignRight title={<FaSearch size="20"/>}>
                            <div className={`${navStyles.searchlist}`}>
                                <Search items={items} />
                                {/*<input type="search" className="form-control h7" placeholder="Search titles"/>*/}
                            </div>
                        </NavDropdown>
                    </div>
                    <div className="client-dropdown">
                        <NavDropdown className="d-lg-inline-block d-none" title={<div className={`${navStyles.ppic} mb-lg-0 mb-2 rounded-circle overflow-hidden`}><Image src={avatar ? avatar : '/images/profile-default.jpg'} className="img-fluid"/></div>} id="collasible-nav-dropdown" alignRight>
                            {/* <Link href={`${href}/myprofile`} passHref><a className="d-block py-2 px-lg-4 px-2">
                                <FaCog className="mr-2" size="23"/> Settings
                            </a></Link>
                            <hr className="m-0" />
                            <div className="pointsCon">
                                <Link href={`${href}/classes-and-programs/points`} passHref><a className="d-block py-2 px-lg-4 px-2" href="">
                                    <Image src="../../images/general/img-bright-star.svg" width={35} className="mr-2"/><span className="classpoints">20 points</span>
                                </a></Link>
                            </div>
                            <hr className="m-0" /> */}
                            <Link href={profileUrl} passHref><a target={email ? '_blank' : ''} className="d-block py-2 px-lg-4 px-2">
                                <FaUserCircle size="23" className="mr-2"/> My Profile
                            </a></Link>
                            <hr className="m-0" />
                            <Link href="javascript:void(0);"><a className="d-block py-2 px-lg-4 px-2" onClick={() => Authenticator.preLogout('/login')}>
                                <FaSignOutAlt size="23" className="mr-2"/> Logout
                            </a></Link>
                        </NavDropdown>
                    </div>
                </>
            }
            
            <style jsx>{`
                        
                .classpoints{
                    color:#000!important;
                }

            `}</style>

            <style jsx global>{`
            
                .search-dropdown .dropdown-menu {
                    height: 35px; 
                }

                .search-dropdown .dropdown-menu .dropdownSearh {
                    height: auto;
                }

                .search-dropdown .dropdown-menu .searchContainer {
                    top: -10px;
                }

                .search-dropdown .dropdown-menu input {
                    font-size: 16px!important;
                }
                
                .search-dropdown .dropdown-menu .dropdownSearh {
                    width: 100%;
                }

                .search-dropdown .dropdown-menu .dropdownItem {
                    padding: 7px 5px!important;
                    font-size: 14px!important;
                }

                // .search-dropdown .dropdown-menu{
                //     padding:0;
                //     width:310px;
                //     min-width: 330px;
                //     border-radius:0;
                //     display:block!important;
                //     height:0;
                //     transition:height .4s ease-in-out;
                //     overflow:hidden;
                //     border:none;
                //     box-shadow:-1px 9px 9px -3px rgba(0,0,0,0.19);
                // }

                // .search-dropdown .dropdown-menu a{
                //     color:#212529;
                // }

                // .search-dropdown .dropdown-menu.show{
                //     height: 250px;
                //     transition:height .4s ease-in-out;
                // }

                // .search-dropdown .dropdown-menu .dropdownItem {
                //     padding: 7px 5px!important;
                //     font-size: 14px!important;
                // }

                // .search-dropdown .dropdown-menu .dropdownSearh {
                //     width: 100%;
                // }
            
                .notification-dropdown .dropdown,
                .client-dropdown .dropdown{
                    position:inherit;
                }

                .notification-dropdown .dropdown-menu{
                    padding:0;
                    width:auto;
                    min-width:auto;
                    border-radius:0;
                    display:block!important;
                    height:0;
                    transition:height .4s ease-in-out;
                    overflow:hidden;
                    border:none;
                    box-shadow:-1px 9px 9px -3px rgba(0,0,0,0.19);
                }

                .notification-dropdown .dropdown-menu.show{
                    height:290px;
                    transition:height .4s ease-in-out;
                }

                .client-dropdown .dropdown-menu{
                    padding:0;
                    width:200px;
                    min-width:200px;
                    border-radius:0;
                    display:block!important;
                    height:0;
                    transition:height .4s ease-in-out;
                    overflow:hidden;
                    border:none;
                    box-shadow:-1px 9px 9px -3px rgba(0,0,0,0.19);
                }

                .client-dropdown .dropdown-menu a{
                    color:#212529;
                }

                .client-dropdown .dropdown-menu.show{
                    height:95px;
                    transition:height .4s ease-in-out;
                }

                @media(max-width:991.98px){

                    .search-dropdown .dropdown-menu,
                    .notification-dropdown .dropdown-menu{
                        width:100%;
                        min-width:100%;
                    }

                    .notification-dropdown .dropdown-menu.show{
                        height:calc(100vh - 103px);
                        overflow-y:scroll;
                    }

                }

                .notification-dropdown .dropdown-menu{
                    width:400px;
                }

                .notification-dropdown .dropdown-menu.show{
                    overflow-y:scroll;
                }
                
            `}</style>

        </Nav>
    )
}

export default RightSectionNav
